export const DownloadIcon = ({
  width,
  height,
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) => {
  return (
    <svg
      width={width || "13"}
      height={height || "13"}
      viewBox="0 0 13 13"
      fill="none"
      className={className}
    >
      <path
        d="M1.4043 10.666H10.667V6.45605H12.0703V12.0693H0V6.45605H1.4043V10.666ZM6.73438 6.71973L7.99023 5.46387L8.98242 6.45605L6.03516 9.40332L6.03418 9.40234L6.0332 9.40332L3.08594 6.45605L4.07812 5.46387L5.33105 6.7168V0H6.73438V6.71973Z"
        fill="black"
      />
    </svg>
  );
};
